export default {
    alert_types_title: "Tipos de alerta",
    alert_types_add: "Agregar",
    alert_types_id: "Id",
    alert_types_name: "Nombre",
    alert_types_code: "Código",
    alert_types_created_on: "Creado en",
    alert_types_parent_id: "Id. del padre",
}